export const Types = {
  RESET_DATA: "wagon/RESET_DATA",
  INDEX: "wagon/INDEX",
  INDEX_SUCCESS: "wagon/INDEX_SUCCESS",
  INDEX_ERROR: "wagon/INDEX_ERROR",
  INACTIVATE: "wagon/INACTIVATE",
  ACTIVATE: "wagon/ACTIVATE",
  SHOW_OR_HIDE_DRAWER: "wagon/SHOW_OR_HIDE_DRAWER",
};

export const Creators = {
  index: (groupId, farmId) => ({
    type: Types.INDEX,
    payload: { groupId, farmId },
  }),
  indexSuccess: (data) => ({
    type: Types.INDEX_SUCCESS,
    payload: { data },
  }),
  indexError: (error) => ({
    type: Types.INDEX_ERROR,
    payload: { error },
  }),
  showOrHideDrawer: (id = null) => ({
    type: Types.SHOW_OR_HIDE_DRAWER,
    payload: { id },
  }),
  inactivateWagon: (groupId, farmId, id) => ({
    type: Types.INACTIVATE,
    payload: { groupId, farmId, id },
  }),
  activateWagon: (groupId, farmId, id) => ({
    type: Types.ACTIVATE,
    payload: { groupId, farmId, id },
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  isDrawerVisible: false,
  wagonId: null,
  error: {},
};

export default function wagon(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.INDEX:
      return { ...state, isLoading: true };
    case Types.INDEX_SUCCESS:
      return { ...state, isLoading: false, data: action.payload.data };
    case Types.INDEX_ERROR:
      return {
        ...state,
        isLoading: false,
        data: null,
        error: action.payload.error,
      };
    case Types.SHOW_OR_HIDE_DRAWER:
      return {
        ...state,
        wagonId: action.payload.id,
        isDrawerVisible: !state.isDrawerVisible,
      };
    case Types.INACTIVATE:
      return { ...state, isLoading: true };
    case Types.ACTIVATE:
      return { ...state, isLoading: true };
    default:
      return state;
  }
}
